import React, { useContext, useLayoutEffect, useState } from "react";
import { PortalContext } from "App";
import OPOfflineIframe from "../../../iframe-component/operation-offline/OPOffIframe";

const AddOfflineMerchant = ({ path }) => {
  const stateContext = useContext(PortalContext);
  const { detailPageState } = stateContext;

  const [isoAgentEmail, setIsoAgentEmail] = useState(undefined);

  useLayoutEffect(() => {
    const sessionState = JSON.parse(sessionStorage.getItem("state"));
    if (detailPageState && detailPageState[path]) {
      setIsoAgentEmail(detailPageState[path].isoAgentEmail);
    } else if (sessionState && sessionState[path]) {
      setIsoAgentEmail(sessionState[path].isoAgentEmail);
    }
  }, [detailPageState[path]]);

  // uses /agent/list with isoAgentEmailRedirect query parameter to redirect into merchant/create with the desired agent email
  const redirectPath = `${isoAgentEmail ? "/agent/list?isoAgentEmailRedirect=" + isoAgentEmail : "/merchant/create"}`;
  return <OPOfflineIframe path={redirectPath} />;
};

export default React.memo(AddOfflineMerchant);
